export const LISTING_FEE_PERCENT = 2;
export const SUCCESS_TAX_PERCENT = 3;

export function listingFee(price) {
  return Math.floor((Number(price) || 0) * LISTING_FEE_PERCENT / 100);
}

export function successTax(gross) {
  return Math.floor((Number(gross) || 0) * SUCCESS_TAX_PERCENT / 100);
}

export function sellerNet(gross) {
  const amount = Number(gross) || 0;
  return Math.max(0, amount - successTax(amount));
}
